<template>
    <table class="table table-hover table-bordered table-md">
        <thead>
            <tr>
                <th>#</th>
                <th>Produk/Tanggal</th>
                <th>Jenis Transaksi</th>
                <th>Nomor Pengiriman / Keterangan </th>
                <th>Supplier/Konsumen</th>
                <th>Barang Masuk</th>
                <th>Barang Keluar</th>
                <th>Total Qty</th>
            </tr>
        </thead>
        <tbody>
        <template v-for="(item,index) in dataList">
            <tr :key="item.id_produk">
                <th> {{ item.no }} </th>
                <th colspan="11">{{item.main.nama_produk}}</th>
            </tr>
            <template v-for="(prList,ind) in item.main.historyList">
                <tr :key="prList.id_transaksi_produk">
                    <td></td>
                    <td> {{ prList.tanggal_terjadi | moment("DD MMMM YYYY") }} </td>
                    <td> {{ prList.value_item }} </td>
                    <td> {{ prList.nomor_pengiriman != '' ? prList.nomor_pengiriman : prList.catatan }} </td>
                    <td> {{ prList.display_name }} </td>
                    <td> {{ produkCallback(ind,index,'masuk') }} </td>
                    <td> {{ produkCallback(ind,index,'keluar') }} </td>
                    <td> {{ prList.qty_recorded }} </td>
                </tr>
            </template>
            <template>
                <!-- <tr>
                    <th colspan="7" style="text-align:right;">
                        Total Barang Tersedia
                    </th>
                    <th>
                        {{ item.main.qty_total }}
                    </th>
                </tr> -->
            </template>
        </template>
        </tbody>
    </table>
</template>

<script>
import Vue from 'vue'

export default {
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        currencyFormat: function(val){
            console.log(val)
            return this.$parent.currencyFormat(val)
        },
        produkCallback: function(ind,index,tipe) {
            if(tipe == 'masuk') {
                return this.dataList[index].main.historyList[ind].qty_accept
            }else if(tipe == 'keluar') {
                return this.dataList[index].main.historyList[ind].qty_send
            }
        }
    },
    props : ['dataList']
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/TableRincian.vue